import React from "react";
import styled, { keyframes } from "styled-components";

const Button = styled.button`
  display: flex;
  padding: var(--sizing-sizing-07, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--sizing-sizing-06, 12px);
  flex: 1 0 0;
  border-radius: 48px;
  background: var(--social-buttons-primary-default-background, #ffffff);
  border: none;
  padding: 12px 24px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease, opacity 0.2s ease;
  width: ${({ $fullWidth, $width }) =>
    $fullWidth ? "100%" : $width ? $width : "auto"};

  &:hover {
    background-color: #f3f4f6;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: #f3f4f6;
  }

  span {
    color: var(--Color-Brand-Primary, #212543);
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */

  }
`;

const Logo = styled.img`
  width: 24px;
  height: 24px;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  border: 2px solid #ddd;
  border-top: 2px solid #1f2937;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: ${spin} 0.6s linear infinite;
`;

const SocialButton = ({
  onClick,
  disabled = false,
  type = "button",
  fullWidth = false,
  width, // new manual width
  loading = false,
  label,
  icon,
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      $fullWidth={fullWidth}
      $width={width}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          {icon && <Logo src={icon} alt={`${label} Logo`} />}
          <span>{label}</span>
        </>
      )}
    </Button>
  );
};

export default SocialButton;
